import * as React from 'react'
import { Icon } from '../Icon'
import { Block } from '../Layout/Block'
import { Text } from '../Text'
const starIcon = require('$icons/star.svg')

interface Props {
  label?: number
  showOnlyStars?: boolean
  rating?: number
}

export const Stars: React.SFC<Props> = ({ label, showOnlyStars, rating }) => {
  const renderStars = () => {
    const value = Math.round(rating)
    let stars = []
    for (let i = 0; i < value; i++) {
      stars.push(<Icon key={i} content={starIcon} color="darkPink" size="s" marginRight="none" />)
    }
    return stars
  }

  if (showOnlyStars) {
    return <Block>{renderStars()}</Block>
  }

  return (
    <Block flex alignItems="center">
      <Block>
        <Icon content={starIcon} size="s" marginRight="tiny" color="darkGrey" />
      </Block>
      {label && <Text weight="medium">{label.toFixed(1)}</Text>}
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Stars/Stars.tsx